import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
const useInstituteLabTestActions = ({ selector, type }) => {
  const navigate = useNavigate()
  const { items: labTests } = useSelector((state: any) => state[selector])
  const handleClick = (event) => {
    const target = event.target as HTMLElement
    const cross = target.closest('[data-cross-id]')
    if (!!cross) {
      const id = cross.getAttribute('data-cross-id')
      const labTest = labTests?.find((labTest: any) => labTest?.id == id)
      if (!!labTest?.id) {
        const slug = `${labTest?.name.toLowerCase().replaceAll(' ', '-')}-${id}`
        const path =
          type == 'Normal'
            ? `/institution/lab-tests/${slug}`
            : `/institution/lab-packages/${slug}`
        navigate(path, {
          state: labTest,
        })
      }
    }
  }
  return {
    handleClick,
  }
}

export default useInstituteLabTestActions
